export default __webpack_public_path__ + "static/media/Poppins-Bold.a02b6809.woff";